import React from 'react';
import theme from "../../assets/theme";
import ApplicationUnderProcess from './components/ApplicationUnderProcess';
import Dashboard from './components/Dashboard';
import { useProfile } from "../../context/ProfileContext";

const Home: React.FC = (props) => {
    // TODO: Add icon in the cards
    const {typography, palette} = theme;

    const { profile } = useProfile();
    const profileData =
        profile ||
        (() => {
            const stored = localStorage.getItem("profile");
            return stored ? JSON.parse(stored) : null;
        })();

    // Show the under-review banner only while the account is still pending; once
    // the admin approves it (or it lands in any other state), render the dashboard.
    const isApplicationUnderProcess =
        profileData?.accountStatus === "PENDING_APPROVAL";

    return (
        <div>
            {
               isApplicationUnderProcess
               ? <ApplicationUnderProcess></ApplicationUnderProcess>
               : <Dashboard></Dashboard>

            }
        </div>
    )
}

export default Home;
